import React, { useState, useEffect, useContext } from 'react';
import { Table, Button, Modal, Descriptions, message, Card, notification } from 'antd';
import listApi from '../../services/api';
import { AuthContext } from '../../context/AuthContext';
import { ReloadOutlined } from "@ant-design/icons";

export default function OrderManagement() {
    const { userData } = useContext(AuthContext);
    const [listOrder, setListOrder] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState(false)

    const fetchListOrder = async () => {
        setLoading(true)
        try {
            const response = await fetch(listApi.listAllOrder, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    session_id: userData.session_id
                })
            });
            const data = await response.json();
            console.log("Check data order----->", data)
            if (data.code === 200) {
                setLoading(false)
                setListOrder(data.list_order);
            }
        } catch (error) {
            setLoading(false)
            console.error("Lỗi khi lấy dữ liệu sản phẩm:", error);
        }
    };

    useEffect(() => {
        console.log(userData.session_id)
        fetchListOrder();
    }, [userData]);

    const columns = [
        {
            title: 'ID',
            dataIndex: 'ID',
            key: 'ID',
        },
        {
            title: 'Tên khách hàng',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Điện thoại',
            dataIndex: 'tel',
            key: 'tel',
        },
        {
            title: 'Thời gian tạo',
            dataIndex: 'create_time',
            key: 'create_time',
        },
        {
            title: 'Trạng thái',
            dataIndex: 'state',
            key: 'state',
            render: (state) => state?.State || 'Không xác định',
        },
        {
            title: 'Hành động',
            key: 'action',
            render: (text, record) => (
                <Button type="primary" onClick={() => handleViewOrder(record)}>
                    Xem chi tiết
                </Button>
            ),
        },
    ];

    const handleViewOrder = (order) => {
        setSelectedOrder(order);
        setIsModalVisible(true);
    };

    const handleConfirmOrder = async (id) => {
        console.log("Check orderID---->", id)
        try {
            const response = await fetch(listApi.confirmOrder, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    session_id: userData.session_id,
                    order_id: id
                })
            });
            const data = await response.json();
            console.log("Check data order----->", data);
            if (data.code === 200) {
                      notification.success({
                    message: 'Thành công!',
                    description: 'Xác nhận đơn hàng thành công',
                    placement: 'topRight',
                  });
                setIsModalVisible(false);
                fetchListOrder();
            }
        } catch (error) {
            notification.success({
                message: 'Thất bại!',
                description: 'Xác nhận đơn hàng thất bại',
                placement: 'topRight',
              });
            console.error("Lỗi khi lấy dữ liệu sản phẩm:", error);
        }
    };

    const handleCompleteOrder = async (id) => {
        console.log("Check orderID---->", id)
        try {
            const response = await fetch(listApi.completeOrder, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    session_id: userData.session_id,
                    order_id: id
                })
            });
            const data = await response.json();
            console.log("Check data order----->", data);
            if (data.code === 200) {
                notification.success({
                    message: 'Thành công',
                    description: 'Hoàn thành đơn hàng',
                    placement: 'topRight',
                  });
          
                setIsModalVisible(false);
                fetchListOrder();
            }
        } catch (error) {
            notification.error({
                message: 'Thất bại',
                description: 'Không thể hoàn thành đơn hàng',
                placement: 'topRight',
              });
            console.error("Lỗi khi lấy dữ liệu sản phẩm:", error);
        }
    };

    const handleCancelOrder = async (id) => {
        console.log("Check orderID---->", id)
        try {
            const response = await fetch(listApi.cancelOrder, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    session_id: userData.session_id,
                    order_id: id
                })
            });
            const data = await response.json();
            console.log("Check data order----->", data);
            if (data.code === 200) {
                notification.success({
                    message: 'Thành công!',
                    description: 'Hủy đơn hàng thành công',
                    placement: 'topRight',
                  });
                setIsModalVisible(false);
                fetchListOrder();
            }
        } catch (error) {
            notification.error({
                message: 'Thất bại!',
                description: 'Lỗi khi lấy dữ liệu sản phẩm',
                placement: 'topRight',
              });
            console.error("Lỗi khi lấy dữ liệu sản phẩm:", error);
        }
    };

    const showCancelConfirm = (id) => {
        Modal.confirm({
            title: 'Bạn có chắc chắn muốn hủy đơn hàng này không?',
            okText: 'Có',
            okType: 'danger',
            cancelText: 'Không',
            onOk() {
                handleCancelOrder(id);
            },
        });
    };


    const getStateColor = (state_id) => {
        switch (state_id) {
            case 1:
                return { backgroundColor: 'yellow' };
            case 2:
                return { backgroundColor: '#00beff', color: 'white' };
            case 5:
                return { backgroundColor: 'green', color: 'white' };
            case 6:
                return { backgroundColor: 'red' };
            default:
                return {};
        }
    };


    return (
        <div>
            <Card
                title="📊QUẢN LÝ ĐƠN HÀNG"
                extra={
                    <>
                        <Button 
                            loading={loading}
                            onClick={fetchListOrder}
                            icon={<ReloadOutlined />} 
                            style={{ marginRight: "10px" }}>
                                Tải Lại
                        </Button>
                    </>
                }
                style={{ marginBottom: "20px", }}
            >
                <Table loading={loading} columns={columns} dataSource={listOrder} pagination={{ pageSize: 10 }} />
            </Card>

            <Modal
                title="Chi tiết đơn hàng"
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={[
                    selectedOrder?.state_id === 1
                        ? (
                            <>
                                <Button style={{ background: 'red' }} key="submit" type="primary" onClick={() => showCancelConfirm(selectedOrder?.ID)}>
                                    Hủy đơn hàng
                                </Button>
                                <Button key="submit" type="primary" onClick={() => handleConfirmOrder(selectedOrder?.ID)}>
                                    Xác nhận đơn hàng
                                </Button>
                            </>
                        )
                        :
                        selectedOrder?.state_id === 5 || selectedOrder?.state_id === 6
                            ?
                            (
                                null
                            )
                            :
                            (
                                <Button key="submit" type="primary" onClick={() => handleCompleteOrder(selectedOrder?.ID)}>
                                    Hoàn thành đơn hàng
                                </Button>
                            ),
                ]}
            >

                {selectedOrder && (
                    <Descriptions bordered column={1}>
                        <Descriptions.Item label="Tên khách hàng">{selectedOrder.name}</Descriptions.Item>
                        <Descriptions.Item label="Điện thoại">{selectedOrder.tel}</Descriptions.Item>
                        <Descriptions.Item label="Danh sách sản phẩm">
                            {selectedOrder.list_item.map(item => (
                                console.log("Check selected order--->", { selectedOrder }),
                                <div key={item.id}>
                                    <p>{item.product_name} - {item.number_item} x {item.price_item.toLocaleString()}đ</p>
                                </div>
                            ))}
                        </Descriptions.Item>
                        <Descriptions.Item label="Ưu đãi">
                            {selectedOrder.discount !== null && selectedOrder.discount !== undefined
                                ? selectedOrder.discount.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })
                                : 'Không xác định'}
                        </Descriptions.Item>
                        <Descriptions.Item label="Tổng số tiền">
                            {selectedOrder.total_order !== null && selectedOrder.total_order !== undefined
                                ? selectedOrder.total_order.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })
                                : 'Không xác định'}
                        </Descriptions.Item>

                        <Descriptions.Item label="Trạng thái" style={getStateColor(selectedOrder.state_id)}>
                            {selectedOrder.state?.State || 'Không xác định'}
                        </Descriptions.Item>

                    </Descriptions>
                )}

            </Modal>
        </div>
    );
}
